import { type FC } from 'react';
import { VStack, type StackProps } from '@chakra-ui/react';
import { UiDivider } from '@/lib/ui/Divider';

export interface UiVStackProps extends StackProps {
  enableShadow?: boolean
  enableDivider?: boolean
}

export const UiVStack: FC<UiVStackProps> = ({
  enableShadow = false,
  enableDivider = false,
  ...props
}) => {
  return (
    <VStack
      divider={ enableDivider
        ? (
          <UiDivider
            height={'1px'}
            backgroundColor={'blackAlpha.300'}
          />
        )
        : undefined}
      shadow={enableShadow ? 'lg' : 'none'}
      {...props}
    />
  );
};
